import request from '@request/index';
import { I18N_URL } from '@request/config';
const apiPrefix = `${I18N_URL}/i18n`;
/**
 * 从后端获取
 * 并设置多语言列表
 * @param app
 */
export async function reqLangList() {
  return request.get(`${apiPrefix}/dictionary/getLang`);
}
/**
 * 获取并返回该系统默认的语言
 * @returns
 */
export async function reqDefaultLang() {
  return request.get(`${apiPrefix}/dictionary/getDefaultLang`);
}
/**
 * 根据当前语言获取翻译数据
 * @param app
 * @param langType
 * @returns
 */
export async function reqLangJson(langType: string) {
  return request.get(`${apiPrefix}/sysInternational/getSysInternationalList`, {
    params: {},
    headers: {
      langType
    }
  });
}
